import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerSellComponent } from './dealer-sell.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { ProviderBuyOfferComponent } from '../provider/provider-buy-offer/provider-buy-offer.component';
import { ProviderBuyComponent } from '../provider/provider-buy/provider-buy.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { MenuNode } from '../common/dealer-menu/dealer-menu.component';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';
import { SessionBasicData, MenuCode } from 'src/app/public/common/constants/session-basic-data';


const menuItems: MenuNode[] = SessionBasicData.getChildren(MenuCode.SELL)


const routes2: Routes = SessionBasicData.sessionMenu
  //.filter(item => item.component) // only those with components
  .filter(item => item.code === MenuCode.SELL)
  .map(item => ({
    path: ''+item.link,
    canActivate: [AuthGuard], 
    component: ProviderBuyComponent, 
    data: { transactionStages: [ TransactionStage.PENDING ] }
  }));

  const routes22: Routes = [
  { path: '', component: DealerSellComponent,
    children: routes2
  },
];

const routes1: Routes = [
  { path: '', component: DealerSellComponent,
    children: [
    ]
  },
];

menuItems.forEach(
  (menuItem) => {
    routes1[0]!.children!.push({ path: ''+menuItem.link, canActivate: [AuthGuard], component: ProviderBuyComponent })
  }
)

routes1[0]!.children!.push({ path: '**', component: NotFoundComponent })

//console.log(routes)

let routes: Routes = [
  { path: '', component: DealerSellComponent,
    children: [
      { path: 'offer', canActivate: [AuthGuard], component: ProviderBuyOfferComponent },
      { path: 'prospects', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.CONFIRMED ] }   },
      { path: 'ongoing', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }   },
      { path: 'completed', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }  }, 
    
      { path: '**', component: NotFoundComponent },
    ]
  },
];

//console.log(routes)

//console.log(routes1)

/*
const routes: Routes = [
  { path: '', component: DealerSellComponent,
    children: [
      { path: 'offer', canActivate: [AuthGuard], component: ProviderBuyOfferComponent  },
      { path: 'prospects', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }   },
      { path: 'ongoing', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }   },
      { path: 'completed', canActivate: [AuthGuard], component: ProviderBuyComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }  }, 
    
      { path: '**', component: NotFoundComponent },
    ]
  },
];

*/

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerSellRoutingModule { }
